<template>
  <div class="details">

    <div class="page__header">
      <div class="page__title" v-if="$route.params.entity == 'customer'">{{
        $t(`accountDetails.${"costumerTitle"}`)
      }} </div>
      <div class="page__title" v-if="$route.params.entity == 'lead'">LEAD {{
        $t(`accountDetails.${"costumerTitle"}`) }}</div>
      <div class="page__title" v-if="$route.params.entity == 'user'">{{ $t(`accountDetails.${"userTitle"}`)
      }}
      </div>
      <div class="page__right"
        v-if="($route.params.entity === 'customer' || $route.params.entity === 'potential-customer') && customer && customer.customer_status && customer.customer_status.id == 1">

        <form class="search search--filter" @submit.prevent="keywordsSearch()">
          <div class="search__wrapper">
            <input class="search__search" ref="search" :class="{ 'search__search--active': searchKeywords }" type="text"
              v-model="searchKeywords" />
            <div class="search__icon"></div>
            <div class="search__splitter"></div>
          </div>
          <div class="search__filter" ref="filterToggler" @click="showSearchFilter = !showSearchFilter"></div>
          <SearchFilter :searchType="'customer'" v-if="showSearchFilter" :filterToggler="$refs.filterToggler"
            :toggleSearchFilter="(state) => {
              showSearchFilter = state;
            }
              " />
        </form>



        <button v-if="!detailsLoading" class="button button--default button--animated"
          @click="$store.commit('setShowAddCustomerServicesModal', true)">
          <div class="button__icon"></div>
        </button>
        <button v-else class="button button--default button--animated">
          <Loading />
        </button>
      </div>

      <div class="page__right" v-else-if="$route.params.entity === 'lead'">
        <button v-if="!detailsLoading" class="button button--default button--animated"
          @click="$store.commit('setShowAddLeadModal', true)">
          <div class="button__icon"></div>
        </button>
        <button v-else class="button button--default button--animated">
          <Loading />
        </button>
      </div>

      <div class="page__right" v-if="$route.params.entity == 'user'">
        <form class="search" @submit.prevent="searchUsersForms()">
          <input class="search__search" :class="{ 'search--active': searchKeywordsUsers.length }" type="text"
            v-model="searchKeywordsUsers" />
        </form>
        <button v-if="$checkRolePermission('user_create')" class="users__button button button--default"
          @click="$store.commit('setShowAddUserModal', true)">
          {{ $t(`settings.user.${"addUserBtn"}`) }}
        </button>
      </div>
    </div>
    <div class="details__content">
      <div class="detail box box--default">
        <Loading v-if="detailsLoading" />
        <template
          v-else-if="($route.params.entity === 'customer' || $route.params.entity === 'potential-customer' || $route.params.entity === 'lead') ? (customer && customer.id) : (user && user.id)">
          <div v-if="!($route.params.entity === 'user' && loggedUser.id == $route.params.id)"
            class="detail__edit icon icon__edit" @click="
              $route.params.entity === 'lead'
                ? editLead(customer)
                : ($route.params.entity === 'customer' || $route.params.entity === 'potential-customer')
                  ? editCustomer(customer.id)
                  : editUser()
              "></div>
          <div class="detail__info">
            <div class="detail__avatar">
              <img v-if="photo" :src="photo" alt="" />
              <div class="detail__avatar-company-icon" v-else-if="memberType === statics.memberTypes.company">
                <img src="../assets/icons/default/Bold 2px-building.svg" alt="" />
              </div>
              <div v-else class="initials" :style="{ background: customer.color || '#7f8fa4' }">
                {{ parseInitials(customer.first_name, customer.last_name) }}
              </div>
            </div>

            <div class="detail__splitter"></div>

            <div class="detail__profile">
              <div v-if="
                $route.params.entity === 'customer' ||
                $route.params.entity === 'potential-customer' ||
                $route.params.entity === 'lead'
              " class="detail__name">
                <span v-if="memberType === statics.memberTypes.company">{{
                  customer.company_name
                }}</span>
                <span v-else-if="memberType === statics.memberTypes.private">{{
                  `${customer.first_name} ${customer.last_name}`
                }}</span>
              </div>
              <div v-else class="detail__name">
                {{ user.first_name }} {{ user.last_name }}
              </div>



              <template v-if="
                $route.params.entity === 'customer' ||
                $route.params.entity === 'potential-customer' ||
                $route.params.entity === 'lead'
              ">
                <div class="detail__emails" v-if="email.length">
                  <div class="detail__emails__wrapper">
                    <div class="detail__email__edit">
                      <div class="detail__email">
                        {{ email[0].email }}
                      </div>
                      <div class="email__edit__icon icon icon__edit" @click="editEmail(customer.id, email[0].id)"></div>
                    </div>

                    <div v-if="email[0].online_shipping" style="display: flex;">
                      <div class="icon icon__tick__color"></div>
                      <p class="detail__email">{{ t("editEmailModal.onlineShipping")
                      }}</p>
                    </div>
                  </div>

                  <div class="detail__email detail__email--secondary" :style="showDetails
                    ? { maxHeight: '1000px', marginTop: '10px', marginBottom: '10px' }
                    : { maxHeight: '0', margin: '0', }
                    ">
                    <div v-for="(email, index) in email" :key="`email${email.id}`">
                      <div v-if="index !== 0" class="detail__emails__wrapper">
                        <div class="detail__email__edit">
                          <p style="height: 22px;">{{ email.email }}</p>
                          <div class="email__edit__icon icon icon__edit" style="height: 22px;"
                            @click="editEmail(customer.id, email.id)"></div>
                        </div>
                        <div v-if="email.online_shipping" style="display: flex;">
                          <div class="icon icon__tick__color"></div>
                          <p class="detail__email">{{ t("editEmailModal.onlineShipping")
                            }}</p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="details__phones" v-if="phone.length">
                  <div class="detail__phone">
                    {{ phone[0].phone }}
                  </div>
                  <div class="detail__phone detail__phone--secondary" v-for="(phone, index) in phone"
                    :key="`phone${phone.id}`" :style="showDetails
                      ? { maxHeight: '16px' }
                      : { maxHeight: '0', margin: '0' }
                      ">
                    <span v-if="index !== 0">{{ phone.phone }}</span>
                  </div>
                </div>
              </template>

              <template v-else>
                <div class="detail__email">
                  {{ email[0] || "-" }}
                </div>
                <div class="detail__phone">
                  {{ phone }}
                </div>
              </template>
            </div>

            <div class="detail__splitter"></div>

            <div class="det" @click="showDetails = !showDetails">
              <div class="det__header">
                <div class="det__title">
                  <span v-if="showDetails">{{ $t(`addSearchFamilyMemberModal.${"lessDetails"}`) }}</span>
                  <span v-else>{{ $t(`addSearchFamilyMemberModal.${"moreDetails"}`) }}</span>
                </div>
                <div class="det__chevron" :class="{ 'det__chevron--more': showDetails }"></div>
              </div>
            </div>

            <div class="detail__splitter"></div>
            <div class="detail__about">
              <template v-if="memberType === statics.memberTypes.private">
                <div class="detail__label">{{ $t(`searchCustomerFields.${"birthday"}`) }}:</div>
                <div class="detail__detail">{{ birthday }}</div>
              </template>
              <template v-if="memberType === statics.memberTypes.company">
                <div class="detail__label">Ansprechspartner:</div>
                <div class="detail__detail">
                  <span>{{ comment }} </span>
                </div>
              </template>
              <div class="detail__label">Address:</div>
              <div class="detail__detail">
                <span>{{ street }}</span> <span>{{ number }}</span>
              </div>
              <div class="detail__label">Team:</div>
              <div class="detail__detail">
                <span>{{ teamName }} </span>
              </div>
              <div class="detail__label">Zip / City:</div>
              <div class="detail__detail">
                <span>{{ zip }}</span> <span>{{ city }}</span>
              </div>
              <template v-if="memberType === statics.memberTypes.private">
                <div class="detail__label">Nationality:</div>
                <div class="detail__detail">
                  {{ country }}
                </div>
              </template>


              <template v-if="$route.params.entity === 'user'">
                <div class="detail__label">{{ $t(`searchCustomerFields.${"birthday"}`) }}:</div>
                <div class="detail__detail">
                  {{ birthday }}
                </div>
                <div class="detail__label">Finma Nr. :</div>
                <div class="detail__detail">
                  {{ finmaNr }}
                </div>
              </template>
            </div>

            <div class="detail__splitter"></div>
            <div class="detail__about" ref="details" :style="showDetails
              ? { maxHeight: `${detailsHeight()}px` }
              : { maxHeight: '0px' }
              ">
              <template>


                <div class="detail__label">Sachbearbeiter: </div>
                <div class="detail__detail">
                  {{ sachbearbeiter }}
                </div>
              </template>
              <div class="detail__label">Language:</div>
              <div class="detail__detail">{{ language }}</div>
              <div class="detail__label">Job:</div>
              <div class="detail__detail">{{ job }}</div>
              <div class="detail__label">Employer:</div>
              <div class="detail__detail">{{ employer }}</div>
              <div class="detail__label">AHV Nr.:</div>
              <div class="detail__detail">
                {{ ahvNr }}
              </div>
              <div class="detail__label">IBAN:</div>
              <div class="detail__detail">
                {{ iBan }}
              </div>
              <div class="detail__label">{{ $t('addCompanyModal.bankname') }}</div>
              <div class="detail__detail">
                {{ bankName }}
              </div>
            </div>
          </div>

          <div class="detail__members user-teams" v-if="$route.params.entity === 'user' && teams && teams.length > 0">
            <div class="member user-team" v-for="(team, index) in teams" :key="team.id"
              :style="{ zIndex: `${98 - index}` }" @click.stop="showTeamDropdown = team.id">
              <div class="member__overlay"></div>
              <div class="member__icon">
                <span>
                  <img src="../assets/icons/default/team_icon_grey.svg">
                </span>

              </div>
              <div class="member__name family_member_name" style="padding: 0;">
                <p>{{ team.name }}</p>
              </div>
              <div class="table icon icon__dots" @click.stop="showTeamDropdown = team.id">

                <MembersActionDropdown v-if="showTeamDropdown === team.id" @toggleDropdown="showTeamDropdown = null"
                  :isTax=true :onTaxes="function () { openTeamTaxes(team) }" />
              </div>
            </div>
          </div>

          <div class="detail__members" v-if="
            $route.params.entity === 'customer' ||
            $route.params.entity === 'potential-customer' ||
            $route.params.entity === 'lead'
          ">
            <div class="member" :class="[
              `member--${parseMemberGender(member.gender_id)}`,
              { 'member--active': customer && customer.id === member.id },
            ]" v-for="(member, index) in customerMembers" :key="member.id" :style="{ zIndex: `${98 - index}` }"
              @click="selectMember(member.id)">
              <div class="member__overlay"></div>

              <div class="member__icon" v-if="member.gender">
                <span v-if="member.gender.id == 1">
                  <img src="../assets/icons/default/male_user_icon.svg">
                </span>

                <span v-if="member.gender.id == 2">
                  <img src="../assets/icons/default/female_user_icon.svg">
                </span>
              </div>
              <div class="member__name family_member_name">
                <p>{{ parseCustomerMemberName(member) }}</p>
              </div>
              <div v-if="member.parent_id" @click.stop="showActionsDropdown = member.id" class="table icon icon__dots">

                <MembersActionDropdown v-if="showActionsDropdown === member.id"
                  @toggleDropdown="showActionsDropdown = null"
                  :onEdit="function () { selectMember(member.id); editCustomer(member.id) }"
                  :onDelete="function () { deleteMember(member.id, member) }"
                  :onSeparate="function () { separateMember(member.id, member) }" :isTax=false />
              </div>
            </div>

            <button class="button button--default" @click="openAddMemberModal()">
              <div class="button__icon"></div>
              <div class="button__text">
                {{ $t(`accountDetails.${"details"}.${"addMemberButton"}`) }}
              </div>
            </button>
          </div>
          <button v-if="$route.params.entity === 'user'" type="button"
            class="button button--default detail__password-button"
            @click="$store.commit('setShowResetPasswordModal', true)">
            Reset Password
          </button>
        </template>
      </div>
      <div class="container">
        <div class="tabs">
          <template v-if="
            ($route.params.entity === 'customer' ||
              $route.params.entity === 'potential-customer') && customer
          ">
            <div v-if="$checkRolePermission('policy_access')" class="tab tab--policy" @click="changeTab(0)"
              :class="{ 'tab--active': activeTab === 0 }">
              <span>{{ $t(`accountDetails.${"tabs"}.${"policy"}`) }}</span>
            </div>

            <div class="tab tab--policy" @click="changeTab(9)" :class="{ 'tab--active': activeTab === 9 }">
              <span>{{ $t(`accountDetails.${"tabs"}.${"offers"}`) }}</span>
            </div>

            <div v-if="$checkRolePermission('pendency_access')" class="tab tab--pendencies" @click="changeTab(1)"
              :class="{ 'tab--active': activeTab === 1 }">
              <span>{{ $t(`accountDetails.${"tabs"}.${"pendencies"}`) }}</span>
            </div>

            <div v-if="$checkRolePermission('note_access')" class="tab tab--notes" @click="changeTab(2)"
              :class="{ 'tab--active': activeTab === 2 }">
              <span>{{ $t(`accountDetails.${"tabs"}.${"notes"}`) }}</span>
            </div>

            <div class="tab tab--mandate" :class="{ 'tab--active': activeTab === 3 }" @click="changeTab(3)">
              <span>{{ $t(`accountDetails.${"tabs"}.${"mandate"}`) }}</span>
            </div>

            <div v-if="$checkRolePermission('call_access')" class="tab tab--calls" @click="changeTab(4)"
              :class="{ 'tab--active': activeTab === 4 }">
              <span>{{ $t(`accountDetails.${"tabs"}.${"calls"}`) }}</span>
            </div>

            <div v-if="$checkRolePermission('potential_policy_access')" class="tab tab--policy" @click="changeTab(5)"
              :class="{ 'tab--active': activeTab === 5 }">
              <span>
                {{ $t(`accountDetails.${"tabs"}.${"potential"}`) }}
              </span>
            </div>

            <div v-if="$checkRolePermission('policy_invoice_access')" class="tab tab--payments" @click="changeTab(6)"
              :class="{ 'tab--active': activeTab === 6 }">
              <span>
                {{ $t(`accountDetails.${"tabs"}.${"payment"}`) }}
              </span>
            </div>

            <div v-if="$checkRolePermission('policy_accident_access')" class="tab tab--accidents" @click="changeTab(7)"
              :class="{ 'tab--active': activeTab === 7 }">
              <span>
                {{ $t(`accountDetails.${"tabs"}.${"accident"}`) }}
              </span>
            </div>

            <div class="tab tab--archives" :class="{ 'tab--active': activeTab === 8 }" @click="changeTab(8)">
              <span>{{ $t(`accountDetails.${"tabs"}.${"archives"}`) }}</span>
            </div>
          </template>

          <template v-else-if="$route.params.entity === 'lead'">
            <div v-if="$checkRolePermission('policy_access')" class="tab tab--policy"
              :class="{ 'tab--active': activeTab === 10 }">
              <span>Leads</span>
            </div>
          </template>

          <template v-else-if="$route.params.entity === 'user'">
            <div class="tab tab--policy" :class="{ 'tab--active': activeTab === 0 }" @click="changeTab(0)">

              <span>{{ $t(`accountDetails.${"tabs"}.${"notifications"}`) }}</span>
            </div>
            <div class="tab tab--policy" @click="changeTab(1); getUserAuthLog($route.params.id)"
              :class="{ 'tab--active': activeTab === 1 }">

              <span>{{ $t(`accountDetails.${"tabs"}.${"authLogs"}`) }}</span>
            </div>
          </template>
        </div>

        <div class="content">
          <template v-if="
            ($route.params.entity === 'customer' ||
              $route.params.entity === 'potential-customer') && customer
          ">
            <transition name="fade" mode="in-out">
              <div>
                <PolicyTable v-if="activeTab === 0 && $checkRolePermission('policy_access')" :policies="policies"
                  :terminations="terminations" :detailsLoading="detailsLoading"
                  :expandedPolicyId="$route.params.subEntityType === 'policy' ? Number($route.params.subEntityId) : null"
                  :class="{ content__top: activeTab === 0 }" />

                <PendenciesTable v-if="activeTab === 1 && $checkRolePermission('pendency_access')" :expandedPendencyId="$route.params.subEntityType === 'pendency'
                  ? Number($route.params.subEntityId)
                  : null
                  " :class="{ content__top: activeTab === 1 }" />

                <NotesTable v-if="activeTab === 2 && $checkRolePermission('note_access')"
                  :class="{ content__top: activeTab === 2 }" />

                <CallsTable v-if="activeTab === 4 && $checkRolePermission('call_access')"
                  :class="{ content__top: activeTab === 4 }" />

                <PotentialPolicyTable v-if="activeTab === 5 && $checkRolePermission('potential_policy_access')"
                  :potentialPolicies="potentialPolicies" :detailsLoading="detailsLoading"
                  :class="{ content__top: activeTab === 5 }" />

                <Invoices v-if="activeTab === 6 && $checkRolePermission('policy_invoice_access')"
                  :class="{ content__top: activeTab === 6 }" :detailsLoading="detailsLoading" :policies="policies" />

                <Accidents v-if="activeTab === 7 && $checkRolePermission('policy_accident_access')"
                  :class="{ content__top: activeTab === 7 }" :detailsLoading="detailsLoading" :policies="policies" />

                <MandatesTable v-if="activeTab === 3" :class="{ content__top: activeTab === 3 }" />

                <OffersTable v-if="activeTab === 9" :class="{ content__top: activeTab === 9 }" />
              </div>
            </transition>
          </template>

          <template v-if="
            $route.params.entity === 'lead'
          ">
            <transition name="fade" mode="in-out">
              <CustomerLeadsTable v-if="activeTab === 10" :class="{ content__top: activeTab === 10 }" />
            </transition>
          </template>

          <template v-else-if="$route.params.entity === 'user'">
            <transition name="fade" mode="in-out">
              <div>
                <div v-if="activeTab === 0" class="notifications">
                  <NoData v-if="!notifications.length" :type="'notifications'" />
                  <template v-else>
                    <Notification v-for="notification in notifications" :key="notification.id"
                      :notification="notification" />
                  </template>

                </div>
                <div v-if="activeTab === 1" class="logs">
                  <template v-if="logsLoading">
                    <Loading />
                  </template>
                  <template v-else>
                    <NoData v-if="!userAuthLog.data.length" :type="'authLogs'" />
                    <template v-else>
                      <div class="auth-wrapper">
                        <div class="auth-row" v-for="auth in userAuthLog.data" :key="auth.id">
                          <div class="info-icon">
                            <img src="../assets/icons/default/info_icon2.svg" />
                          </div>
                          <div class="auth-el-wrapper">
                            <div class="auth-el-title">
                              <p>IP Address: </p>
                            </div>

                            <div class="auth-el-icon">
                              <div class="icon icon__ip"></div>
                              <p>{{ auth.ip_address }}</p>
                            </div>
                          </div>

                          <div class="auth-el-wrapper">
                            <div class="auth-el-title">
                              <p>User Agent: </p>
                            </div>

                            <div class="auth-el-icon">
                              <div class="icon icon__browser"></div>
                              <p>{{ auth.user_agent }}</p>
                            </div>
                          </div>

                          <div class="auth-el-wrapper auth-el-wrapper-date">
                            <div class="auth-el-title">
                              <p>Login At: </p>
                            </div>

                            <div class="auth-el-icon">
                              <div class="icon icon__date"></div>
                              <p>{{ formatDate(auth.login_at) }}</p>
                            </div>

                            <div class="auth-el-icon">
                              <div class="icon icon__time"></div>
                              <p>{{ formatTime(auth.login_at) }}</p>
                            </div>
                          </div>
                        </div>
                      </div>

                      <Pagination :limit="3" :data="userAuthLog" @pagination-change-page="getResults">
                      </Pagination>
                    </template>
                  </template>
                </div>
              </div>
            </transition>
          </template>
        </div>
      </div>
    </div>
  </div>
</template>

<!-- / -->
<script setup>
import {
  ref,
  computed,
  watch,
  onMounted,
  onBeforeUnmount
} from "vue";
import {
  useRoute, useRouter
  // , 
  // onBeforeRouteUpdate 
} from "vue-router";
import { useStore } from "vuex";
import moment from "moment";
import _ from "lodash";

// Component Imports
import NoData from "@/partials/NoData";
import PolicyTable from "@/components/AccountDetails/PolicyTable";
import PendenciesTable from "@/components/AccountDetails/PendenciesTable";
import NotesTable from "@/components/AccountDetails/NotesTable";
import CallsTable from "@/components/AccountDetails/CallsTable";
import MandatesTable from "@/components/AccountDetails/MandatesTable";
import OffersTable from "@/components/AccountDetails/OffersTable";
import CustomerLeadsTable from "@/components/AccountDetails/CustomerLeadsTable";
import PotentialPolicyTable from "@/components/AccountDetails/PotentialPolicyTable";
import Accidents from "@/components/AccountDetails/Accidents";
import Loading from "@/partials/Loading";
import Notification from "@/components/Notification";
import Invoices from "@/components/AccountDetails/Invoices";
import MembersActionDropdown from "@/components/MembersActionDropdown";
import SearchFilter from "@/partials/SearchFilter";
import { useI18n } from 'vue-i18n';
import api from "@/api";
import statics from "@/statics";
import {
  parseBirthday,
  parseCustomerMemberName,
  parseInitials,
} from "@/helpers/entityParsers";

const route = useRoute();
const router = useRouter();
const store = useStore();

const { t } = useI18n();

const details = ref(null);

const showTeamDropdown = ref(false);
const showActionsDropdown = ref(null);
const detailsLoading = ref(true);
const showDetails = ref(false);

const searchKeywordsUsers = ref("");
const searchKeywords = ref("");
const showSearchFilter = ref(false);
const selectedAgents = ref([]);
const selectedCompanyTypes = ref([]);
const selectedCompanies = ref([]);
const selectedBranchCategories = ref([]);
const selectedPolicyStatuses = ref([]);
const hasTerminations = ref("");
const startDateFrom = ref("");
const startDateTo = ref("");
const endDateFrom = ref("");
const endDateTo = ref("");
const submitDateFrom = ref("");
const submitDateTo = ref("");
const paymentStatus = ref("");
const searchZip = ref("");
const searchBirthday = ref("");

const userAuthLog = ref({});
const logsLoading = ref(false);
const lastFetchedId = ref(null);
const isFetching = ref(false);

// Helper function to extract initial tab configuration
const getInitialTab = () => {
  if (route.query.tab !== undefined) {
    return parseInt(route.query.tab);
  }

  const tabMap = { pendency: 1, policy: 0 };
  if (route.params.subEntityType && tabMap[route.params.subEntityType] !== undefined) {
    return tabMap[route.params.subEntityType];
  }

  return route.params.entity === "potential-customer" ? 5 : 0;
};

const activeTab = ref(getInitialTab());

// Vuex Store Mapping (Computed Properties)
const customer = computed({
  get: () => store.getters.customer,
  set: (value) => store.commit("setCustomer", value),
});
const customerMembers = computed(() => store.getters.customerMembers);
const user = computed({
  get: () => store.getters.user,
  set: (value) => store.commit("setUser", value),
});
const loggedUser = computed(() => store.getters.loggedUser);

const photo = computed(() => {
  if (
    (route.params.entity === "customer" || route.params.entity === "potential-customer") &&
    customer.value && customer.value.photo
  ) {
    return customer.value.photo.preview;
  } else if (route.params.entity === "user" && user.value && user.value.photo) {
    return user.value.photo.preview;
  }
  return null;
});

const teamName = computed(() => {
  if (route.params.entity === "customer" || route.params.entity === "potential-customer") {
    return customer.value && customer.value.team ? customer.value.team.name : null;
  }
  return null;
});

const memberType = computed(() => {
  return route.params.entity === "customer" ||
    route.params.entity === "potential-customer" ||
    route.params.entity === "lead"
    ? customer.value && customer.value.member_type ? customer.value.member_type.id : null
    : null;
});

const birthday = computed(() => {
  if (
    route.params.entity === "customer" ||
    route.params.entity === "potential-customer" ||
    route.params.entity === "lead"
  ) {
    return customer.value && customer.value.birthday
      ? `${moment(customer.value.birthday).format("DD.MM.YYYY")} (${parseBirthday(customer.value.birthday)} years old)`
      : "";
  }
  return user.value && user.value.birthday
    ? `${moment(user.value.birthday).format("DD.MM.YYYY")} (${parseBirthday(user.value.birthday)} years old)`
    : "";
});

const email = computed(() => {
  if (route.params.entity === "customer" || route.params.entity === "potential-customer" || route.params.entity === "lead") {
    return customer.value && Array.isArray(customer.value.customer_emails) && customer.value.customer_emails.length
      ? customer.value.customer_emails
      : [];
  }
  return (user.value && user.value.email) ? [user.value.email] : [];
});

const phone = computed(() => {
  if (route.params.entity === "customer" || route.params.entity === "potential-customer" || route.params.entity === "lead") {
    return customer.value && Array.isArray(customer.value.customer_phones) && customer.value.customer_phones.length
      ? customer.value.customer_phones
      : [];
  }
  return user.value && user.value.phone || "-";
});

const street = computed(() => {
  if (route.params.entity === "customer" || route.params.entity === "potential-customer" || route.params.entity === "lead") {
    return customer.value && Array.isArray(customer.value.customer_addresses) && customer.value.customer_addresses.length
      ? customer.value.customer_addresses[0].street
      : "-";
  }
  return user.value && Array.isArray(user.value.user_addresses) && user.value.user_addresses.length
    ? user.value.user_addresses[0].street
    : "-";
});

const comment = computed(() => {
  if (route.params.entity === "customer" || route.params.entity === "potential-customer" || route.params.entity === "lead") {
    return customer.value && customer.value.comment || "-";
  }
  return user.value && user.value.comment || "-";
});

const number = computed(() => {
  if (route.params.entity === "customer" || route.params.entity === "potential-customer" || route.params.entity === "lead") {
    return customer.value && Array.isArray(customer.value.customer_addresses) && customer.value.customer_addresses.length
      ? customer.value.customer_addresses[0].number
      : "-";
  }
  return user.value && Array.isArray(user.value.user_addresses) && user.value.user_addresses.length
    ? user.value.user_addresses[0].number
    : "-";
});

const zip = computed(() => {
  if (route.params.entity === "customer" || route.params.entity === "potential-customer" || route.params.entity === "lead") {
    return customer.value && Array.isArray(customer.value.customer_addresses) && customer.value.customer_addresses.length
      ? customer.value.customer_addresses[0].zip
      : "-";
  }
  return user.value && Array.isArray(user.value.user_addresses) && user.value.user_addresses.length
    ? user.value.user_addresses[0].zip
    : "-";
});

const city = computed(() => {
  if (route.params.entity === "customer" || route.params.entity === "potential-customer" || route.params.entity === "lead") {
    return customer.value && Array.isArray(customer.value.customer_addresses) && customer.value.customer_addresses.length
      ? customer.value.customer_addresses[0].city
      : "-";
  }
  return user.value && Array.isArray(user.value.user_addresses) && user.value.user_addresses.length
    ? user.value.user_addresses[0].city
    : "-";
});

const language = computed(() => {
  if (route.params.entity === "customer" || route.params.entity === "potential-customer" || route.params.entity === "lead") {
    return customer.value && customer.value.language ? customer.value.language.name : "-";
  }
  return user.value && user.value.language ? user.value.language.name : "-";
});

const job = computed(() => {
  if (route.params.entity === "customer" || route.params.entity === "potential-customer" || route.params.entity === "lead") {
    return customer.value && customer.value.occupation || "-";
  }
  return user.value && user.value.occupation || "-";
});

const employer = computed(() => {
  if (route.params.entity === "customer" || route.params.entity === "potential-customer" || route.params.entity === "lead") {
    return customer.value && customer.value.employer || "-";
  }
  return user.value && user.value.employer || "-";
});

const ahvNr = computed(() => {
  if (route.params.entity === "customer" || route.params.entity === "potential-customer" || route.params.entity === "lead") {
    return customer.value && customer.value.ahv_number || "-";
  }
  return user.value && user.value.ahv_number || "-";
});

const iBan = computed(() => {
  if (route.params.entity === "customer" || route.params.entity === "potential-customer" || route.params.entity === "lead") {
    return customer.value && Array.isArray(customer.value.banks) && customer.value.banks.length
      ? customer.value.banks[0].account
      : "-";
  }
  return user.value && Array.isArray(user.value.user_banks) && user.value.user_banks.length
    ? user.value.user_banks[0].account || "-"
    : "-";
});

const bankName = computed(() => {
  if (route.params.entity === "customer" || route.params.entity === "potential-customer" || route.params.entity === "lead") {
    return customer.value && Array.isArray(customer.value.banks) && customer.value.banks.length
      ? customer.value.banks[0].name
      : "-";
  }
  return user.value && Array.isArray(user.value.user_banks) && user.value.user_banks.length
    ? user.value.user_banks[0].name || "-"
    : "-";
});

const finmaNr = computed(() => {
  if (route.params.entity === "customer" || route.params.entity === "potential-customer" || route.params.entity === "lead") {
    return customer.value && customer.value.finma_nr || "-";
  }
  return user.value && user.value.finma_nr || "-";
});

const country = computed(() => {
  if (route.params.entity === "customer" || route.params.entity === "potential-customer" || route.params.entity === "lead") {
    return customer.value && customer.value.country ? customer.value.country.name_en : "-";
  }
  return user.value && user.value.country ? user.value.country.name_en : "-";
});

const sachbearbeiter = computed(() => {
  if (route.params.entity === "customer" || route.params.entity === "potential-customer" || route.params.entity === "lead") {
    if (customer.value && customer.value.owner) {
      return customer.value.owner.company_name || `${customer.value.owner.first_name} ${customer.value.owner.last_name}`;
    }
  }
  return "-";
});

const policies = computed(() => {
  if (route.params.entity === "customer" || route.params.entity === "potential-customer" || route.params.entity === "lead") {
    return customer.value && customer.value.policies
      ? customer.value.policies.filter((police) => Array.isArray(police.policy_services) && police.policy_services.length)
      : [];
  }
  return null;
});

const potentialPolicies = computed(() => {
  if (route.params.entity === "customer" || route.params.entity === "potential-customer" || route.params.entity === "lead") {
    return customer.value && customer.value.potential_policies || [];
  }
  return [];
});

const terminations = computed(() => {
  if (route.params.entity === "customer" || route.params.entity === "potential-customer" || route.params.entity === "lead") {
    return customer.value && customer.value.terminations || [];
  }
  return null;
});

const notifications = computed(() => {
  if (route.params.entity === "user" && user.value) {
    return user.value.notifications || [];
  }
  return null;
});

const teams = computed(() => {
  if (route.params.entity === "user" && user.value && Array.isArray(user.value.teams)) {
    return user.value.teams;
  }
  return [];
});

// Watchers
watch(
  () => route.query.tab,
  (newTab) => {
    if (newTab !== undefined) {
      activeTab.value = parseInt(newTab);
    } else if (route.params.tab) {
      activeTab.value = parseInt(route.params.tab);
    }
  },
  { immediate: true }
);

watch(
  () => route.params.id,
  (newId, oldId) => {
    if (newId && oldId && newId !== oldId) {
      store.commit("setCustomerDetailsId", newId);
      debouncedFetchEntity();
    }
  }
);

watch(
  () => route.params.subEntityType,
  (newType) => {
    const tabMap = {
      policy: 0,
      pendency: 1,
      note: 2,
      mandate: 3,
      call: 4,
      "potential-policy": 5,
    };

    if (newType && tabMap[newType] !== undefined) {
      activeTab.value = tabMap[newType];
    }
  },
  { immediate: false }
);

// Component Logic (Methods converted to standard functions)
const getUserAuthLog = async (userId, page = 1) => {
  logsLoading.value = true;
  try {
    const response = await api({ requiresAuth: true }).get(`/v1/users/${userId}/authentications?page=${page}`);
    userAuthLog.value = response.data;
    logsLoading.value = false;
  } catch (error) {
    console.error("Error fetching user authentications:", error);
    logsLoading.value = false;
    throw error;
  }
};

const getResults = async (paginationPage) => {
  let page = Number(route.query.page);

  if (Number(paginationPage) !== page) {
    router.replace({
      query: { page: paginationPage },
    });
    page = Number(paginationPage);
  }

  await getUserAuthLog(route.params.id, page);
};

const keywordsSearch = async () => {
  router.push({
    path: "/customers",
    query: {
      page: 1,
      search: searchKeywords.value || undefined,
      agents: selectedAgents.value || undefined,
      companyTypes: selectedCompanyTypes.value || undefined,
      companies: selectedCompanies.value || undefined,
      branchCategories: selectedBranchCategories.value || undefined,
      policyStatuses: selectedPolicyStatuses.value || undefined,
      birthday: searchBirthday.value || undefined,
      zip: searchZip.value || undefined,
      has_terminations: hasTerminations.value || undefined,
      startDateFrom: startDateFrom.value || undefined,
      startDateTo: startDateTo.value || undefined,
      endDateFrom: endDateFrom.value || undefined,
      endDateTo: endDateTo.value || undefined,
      submitDateFrom: submitDateFrom.value || undefined,
      submitDateTo: submitDateTo.value || undefined,
      payment_status: paymentStatus.value || undefined,
    },
  });
};

const fetchEntity = async () => {
  const { id, entity } = route.params;

  if (isFetching.value) {
    return;
  }

  if (
    (entity === "customer" || entity === "potential-customer" || entity === "lead") &&
    customer.value &&
    customer.value.id == id &&
    lastFetchedId.value === `${entity}-${id}`
  ) {
    detailsLoading.value = false;
    return;
  }

  if (entity === "user" && user.value && user.value.id == id && lastFetchedId.value === `${entity}-${id}`) {
    detailsLoading.value = false;
    return;
  }

  isFetching.value = true;
  detailsLoading.value = true;

  try {
    if (entity === "customer" || entity === "potential-customer" || entity === "lead") {
      if (lastFetchedId.value !== `${entity}-${id}`) {
        store.commit("setCustomerMembers", []);
        store.commit("setPendencies", []);
        store.commit("setCalls", []);
        store.commit("setNotes", []);
        store.commit("setMandates", []);
        store.commit("setOffers", []);
      }

      store.commit("setCustomerDetailsId", id);
      await store.dispatch("getGlobalCustomer", id);

      const customerData = store.getters.customer;
      if (customerData) {
        store.commit("setCustomerDetails", customerData);
      }

      lastFetchedId.value = `${entity}-${id}`;
    } else if (entity === "user") {
      const userData = await store.dispatch("getUser", id);
      store.commit("setUser", userData);
      lastFetchedId.value = `${entity}-${id}`;
    } else {
      router.push({ name: "Dashboard" });
    }
  } catch (err) {
    console.error("Error in fetchEntity:", err);
  } finally {
    detailsLoading.value = false;
    isFetching.value = false;
  }
};

// Define Debounce Engine configuration
const debouncedFetchEntity = _.debounce(fetchEntity, 300);

const editEmail = (customerId = null, emailId) => {
  if (customerId == null) customerId = route.params.id;
  if (memberType.value === 1) {
    store.commit("setCompanyToEdit", customerId);
    store.commit("setCompanyIsEdit", true);
    store.commit("setEmailIdToEdit", emailId);
    store.commit("setShowEditCompanyEmailModal", true);
  } else if (memberType.value === 2) {
    store.commit("setPrivateToEdit", customerId);
    store.commit("setPrivateIsEdit", true);
    store.commit("setEmailIdToEdit", emailId);
    store.commit("setShowEditPrivateEmailModal", true);
  }
};

const editCustomer = (customerId = null) => {
  if (customerId == null) customerId = route.params.id;
  if (memberType.value === 1) {
    store.commit("setCompanyToEdit", customerId);
    store.commit("setCompanyIsEdit", true);
    store.commit("setShowAddCompanyModal", true);
  } else if (memberType.value === 2) {
    store.commit("setPrivateToEdit", customerId);
    store.commit("setPrivateIsEdit", true);
    store.commit("setShowAddPrivateModal", true);
  }
};

const editLead = (leadCustomer = null) => {
  if (!leadCustomer) leadCustomer = customer.value;
  store.commit("setLeadCustomerToEdit", leadCustomer);
  store.commit("setShowCustomerLeadModal", true);
};

const editUser = () => {
  if (route.params.entity === 'profile') {
    return;
  } else {
    store.commit("setUserToEdit", route.params.id);
    store.commit("setIsEdit", true);
    store.commit("setShowAddUserModal", true);
  }
};

// const editProfile = () => {
//     router.push({ name: "Dashboard" });
// };

const detailsHeight = () => {
  if (!details.value) return 0;

  return [...details.value.children].reduce((acc, child) => {
    const { marginTop, marginBottom } = window.getComputedStyle(child);
    return (acc += child.clientHeight + parseInt(marginTop) + parseInt(marginBottom));
  }, 0);
};

const openAddMemberModal = () => {
  store.commit("setCustomerToAddMember", route.params.id);
  store.commit("setShowAddFamilyMemberModal", true);
};

const parseMemberGender = (genderId) => {
  let genderClass = "";
  if (genderId === 1) {
    genderClass = "male";
  } else if (genderId === 2) {
    genderClass = "female";
  } else {
    genderClass = "company";
  }
  return genderClass;
};

const getMemberName = (member) => {
  if (!member) {
    return "-";
  }

  if (member.company_name && member.company_name.trim() !== "") {
    return member.company_name;
  }
  
  const firstName = member.first_name || "";
  const lastName = member.last_name || "";
  const fullName = `${firstName} ${lastName}`.trim();

  return fullName !== "" ? fullName : "-";
};

const performDeleteMember = async (memberId) => {
  await store.dispatch("deleteCustomer", memberId);
  lastFetchedId.value = null;
  await fetchEntity();
};

const deleteMember = (memberId, member) => {
  store.commit("setDeleteModal", {
    display: true,
    message: `'${getMemberName(member)}'`,
    action: performDeleteMember,
    id: memberId,
    type: 'delete',
  });
};

const performSeparateMember = async (memberId) => {
  await store.dispatch("separateMember", memberId);
  lastFetchedId.value = null;
  await fetchEntity();
};

const separateMember = (memberId, member) => {
  store.commit("setDeleteModal", {
    display: true,
    message: `'${getMemberName(member)}' ${t(`deleteModal.fromAccount`)}`,
    action: performSeparateMember,
    id: memberId,
    type: 'separate',
  });
};

const selectMember = (memberId) => {
  lastFetchedId.value = null;
  router.push({
    path: `/account-details/customer/${memberId}`,
    query: { tab: 0 }
  });
};

const openTeamTaxes = (team) => {
  store.commit("setUserToEdit", route.params.id);
  store.commit("setIsEdit", true);
  store.commit('setShowTaxesModal', true);
  store.commit('setTeamTaxesToEdit', team);
};

const formatDate = (dateString) => {
  const date = new Date(dateString);
  const day = String(date.getDate()).padStart(2, '0');
  const month = String(date.getMonth() + 1).padStart(2, '0');
  const year = date.getFullYear();
  return `${day}/${month}/${year}`;
};

const formatTime = (dateString) => {
  const date = new Date(dateString);
  const hours = String(date.getHours()).padStart(2, '0');
  const minutes = String(date.getMinutes()).padStart(2, '0');
  return `${hours}:${minutes}`;
};

const searchUsersForms = async () => {
  router.replace({
    path: "/users",
    query: {
      page: 1,
      search: searchKeywordsUsers.value
    },
  });
};

const changeTab = (tabIndex) => {
  activeTab.value = tabIndex;
  router.replace({
    query: { ...route.query, tab: tabIndex }
  });
};

// Lifecycle Hooks
onMounted(async () => {
  debouncedFetchEntity();

  if (loggedUser.value?.teams?.length === 1) {
    await store.dispatch("getSearchCustomerForms", loggedUser.value.teams[0].id);
  }

  if (route.params.entity === 'lead') {
    const handleSubStatus = (cust) => {
      if (!cust) return false;

      const routeId = Number(route.params.id);
      if (cust.id !== routeId) return false;

      const subId = cust.customer_sub_status?.id || cust.customer_sub_status_id;

      if (Number(subId) === 4 && cust.id) {
        router.replace({
          path: `/account-details/customer/${cust.id}`,
          query: { tab: 5 }
        });
        store.commit('setShowAddCustomerServicesModal', true);
      }
      return subId != null;
    };

    if (!handleSubStatus(customer.value)) {
      const unwatch = watch(customer, (newVal) => {
        if (handleSubStatus(newVal)) {
          unwatch();
        }
      });
    }
  }
});

onBeforeUnmount(() => {
  if (debouncedFetchEntity && debouncedFetchEntity.cancel) {
    debouncedFetchEntity.cancel();
  }
});
</script>
<!-- . -->

<style scoped lang="scss">
.auth-el-title {
  width: 90px;
}

.auth-el-wrapper,
.auth-el-icon {
  display: flex;
  align-items: center;

  p {
    line-height: initial !important;
    margin: 0 !important;
    color: var(--text-2) !important;
    font-weight: bold !important;
  }
}

.auth-el-wrapper {
  gap: 10px;
  margin-bottom: 10px;
}

.auth-el-wrapper-date {
  margin-bottom: 0;
}

.auth-el-icon {
  gap: 5px;
  box-shadow: 0px 2px 4px var(--shadow-1);
  border-radius: var(--radius-1);
  background-color: white;
  padding: 5px 10px;
  padding-left: 7px;
  border-radius: 10px;
}

[data-theme="dark"] {
  .auth-el-icon {

    background-color: #313B47;
  }
}


.details {
  overflow: hidden !important;
}

.logs {
  padding: 40px 20px;
  height: 100%;
  overflow: auto;
}

.auth-row {
  padding: 30px 20px;
  background: var(--bg-16);
  border-radius: var(--radius-1);
  position: relative;
  margin-bottom: 30px;

  p {
    color: var(--text-9);
    line-height: 18px;
    font-size: var(--x-small);
    margin-bottom: 10px;

    b {
      margin-right: 10px;
    }

    :last-child {
      margin-bottom: 0;
    }
  }


  .info-icon {
    width: 60px;
    height: 34px;
    position: absolute;
    top: -22px;
    left: 0px;

    border-radius: 50%;

    img {
      width: 100%;
    }

  }
}


.user-team:hover {
  .member__icon {
    span {
      filter: brightness(0) invert(1);
    }

  }

  // .icon__dots{
  //   filter: brightness(0) invert(1);
  // }
}



.search-filter {
  z-index: 10;
}

.email__edit__icon {
  scale: 0.8;
  margin-top: -6px;
}

.icon__tick__color {
  background: url(../assets/icons/default/tick_icon_color.svg) no-repeat center;
}


.details {

  &__content,
  .detail__avatar,
  .det__header,
  .container .tabs,
  .detail__avatar-company-icon {
    display: flex;
  }

  &__avatar,
  .det__header,
  .detail__avatar-company-icon {
    align-items: center;
  }

  &__avatar,
  .detail__avatar-company-icon {
    justify-content: center;
  }
}




.details {
  height: 100%;

  &__content {
    height: calc(100% - 48px - 15px);
  }

  .detail {
    width: 250px;
    margin-right: 20px;
    background: var(--bg-1);
    border-radius: var(--radius-3);
    position: relative;
    overflow: auto;

    &__info {
      padding: 0 10px;
    }

    &__splitter {
      width: 100%;
      height: 2px;
      background: var(--bg-3);
    }

    &__edit {
      position: absolute;
      right: 20px;
      top: 20px;
      cursor: pointer;
    }

    &__avatar {
      width: 115px;
      height: 115px;
      border-radius: 50%;
      border: 4px solid var(--border-2);
      margin: 30px auto;
      overflow: hidden;

      img {
        width: initial;
      }

      &-company-icon {
        background: var(--bg-4);
        width: 100%;

        img {
          width: 70%;
        }
      }
    }

    &__profile {
      margin: 15px 0;
      color: var(--text-9);
    }

    &__name {
      font-size: var(--large);
    }

    &__email__edit {
      display: flex;
      align-items: center;
      justify-content: space-between;
      flex-wrap: wrap;
    }




    &__email,
    &__phone {
      font-size: var(--x-small);
      margin: 5px 0;
      transition: all 0.3s ease;

      &--secondary {
        color: var(--text-2);
        overflow: hidden;
      }
    }

    &__emails {
      margin: 10px 0;
    }

    .det {
      margin: 5px 0;
      cursor: pointer;

      &__header {
        justify-content: space-between;
      }

      &__chevron {
        height: 20px;
        width: 20px;
        background: url("../assets/icons/default/Bold 2px-chevron_down.svg");

        &--more {
          transform: rotate(180deg);
        }
      }

      &__title {
        color: var(--text-2);
        font-size: var(--x-smaller);
      }
    }

    &__label {
      font-size: var(--x-smaller);
      color: var(--text-2);
      margin: 10px 0;
    }

    &__detail {
      color: var(--text-9);
      font-size: var(--x-small);
      margin: 10px 0;
    }

    &__about {
      transition: all 0.3s ease;
      overflow: hidden;
    }

    .member {
      color: var(--text-5);
      background: var(--bg-6);
      margin: 20px 0;
      padding: 15px 0;
      text-align: center;
      position: relative;
      cursor: pointer;

      &__overlay,
      &__name {
        transition: all 0.2s ease-in-out;
      }

      &__overlay {
        position: absolute;
        left: 0;
        top: 0;
        height: 100%;
        width: 2px;
        background: var(--bg-2);
        z-index: 0;
      }

      &__name {
        font-family: var(--muli-text-semi-bold);
        font-size: var(--medium);
        position: relative;
        z-index: 1;
        padding: 0 35px 0 15px;
        word-break: break-all;
      }

      &--male {
        .member__icon {
          background: url("../assets/icons/default/male_user_icon.svg");
        }
      }

      &--female {
        .member__icon {
          background: url("../assets/icons/default/female_user_icon.svg");
        }
      }

      &:hover,
      &--active {
        .member__overlay {
          width: 100%;
        }

        .member__name {
          color: var(--text-1)
        }
      }

      .member__name {
        p {
          word-break: break-word;
          width: 90%;
          margin: 0 auto;
        }
      }

      .family_member_name {
        padding: 0;
        white-space: pre-wrap;
        word-wrap: break-word;
        width: 70%;
        margin: auto;

        p {
          width: 100%;
        }
      }
    }

    &__members {
      margin-top: 40px;

      .button {
        position: relative;

        &__icon {
          background: url("../assets/icons/default/Bold 2px-add.svg");
        }
      }
    }

    .button__icon,
    // .member__icon,
    .icon__delete,
    .icon__dots {
      height: 24px;
      width: 24px;
      position: absolute;
      left: 20px;
      top: 50%;
      transform: translateY(-50%);
    }

    .button__icon {
      left: 5px;
    }

    .button__text {
      width: 85%;
      margin-left: auto;
    }

    .icon__delete {
      right: 10px;
      left: initial;
      z-index: 1;
    }

    .icon__dots {

      right: 10px;
      left: initial;
      z-index: 1;

    }

    &__members .button,
    &__password-button {
      width: 180px;
      margin: auto;
    }

    &__password-button {
      margin-top: 60px;
    }
  }

  .member__icon {
    left: 8px;
    width: 22px;
    height: 22px;
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
  }

  .container {
    width: calc(100% - 250px - 20px);

    .tabs {
      padding-left: 7px;

      .tab {
        color: var(--text-2);
        font-size: var(--medium);
        background: var(--bg-7);
        padding: 12px 25px 18px 25px;
        border-top-right-radius: var(--radius-1);
        border-top-left-radius: var(--radius-1);
        box-shadow: 0px 3px 6px var(--shadow-3);
        position: relative;
        cursor: pointer;

        &__badge {
          position: absolute;
          height: 16px;
          width: 16px;
          top: -6px;
          right: 8px;
          background: var(--bg-8);
          border-radius: 50%;
          color: var(--text-1);
          font-size: 10px;
          text-align: center;
          line-height: 15px;
        }

        // &:not(.tab--policy) {
        //   left: -4px;
        // }

        &--payments {
          z-index: 6;
        }

        &--policy {
          z-index: 5;
        }

        &--accidents {
          z-index: 4;
        }

        &--return {
          z-index: 3;
        }

        &--payments {
          z-index: 2;
        }

        &--activities {
          z-index: 1;
        }

        &--active {
          background: var(--bg-1);
          z-index: 6;
        }
      }
    }

    .content {
      position: relative;
      border-radius: var(--radius-3);
      background: var(--bg-1);
      box-shadow: 0px 2px 4px var(--shadow-1);
      top: -3px;
      z-index: 6;
      height: calc(100% - 48px);
      overflow: auto;

      &__top {
        position: relative;
        z-index: 1;
      }

      :deep(.policies),
      :deep(.accidents),
      :deep(.payments),
      :deep(.mandates) {
        height: 100%;
        background: inherit;
        border-radius: inherit;

        .table {
          &--inner {
            .table__body {
              padding-top: 0;
            }
          }

          &__header {
            box-shadow: 0px 5px 10px var(--shadow-1);
            margin-bottom: 0px;
            z-index: 2;
            position: relative;

            &--inner {
              box-shadow: inset 0px 3px 6px var(--shadow-3) !important;
              background: var(--bg-22);
              border-radius: 0;
              border-bottom: 1px solid var(--border-12);

              .table__label {
                border: 0;
                color: var(--text-13);

                &:first-of-type {
                  padding-left: 0 !important;
                }
              }
            }
          }

          &__label {
            &:first-of-type {
              padding-left: 20px;
            }
          }

          &__body {
            padding-top: 15px;
            height: calc(100% - 36px);
          }

          &__no-data {
            height: 100%;
          }

          &__policies {
            position: relative;
            z-index: 2;
          }
        }

        .policy-wrapper {

          &__accidents,
          &__payments {
            transition: all 0.3s ease;
            overflow: hidden;
          }

          .table__label {
            border: 0;
            text-align: left;
            padding-left: 40px;

            &:first-child {
              padding-left: 55px !important;
            }
          }
        }
      }

      .notifications {
        padding: 40px 20px;
        height: 100%;
        overflow: auto;
      }

      .fade-enter-active,
      .fade-leave-active {
        transition: opacity 0.2s;
        position: absolute;
        width: 100%;
        top: 0;
        left: 0;
      }

      .fade-enter-active {
        z-index: 1;
      }

      .fade-leave-active {
        z-index: -1;
      }

      .fade-enter,
      .fade-leave-to {
        opacity: 0;
      }
    }
  }
}

.select-user-team {
  background-color: transparent !important;
  // border: 1px solid black;
  width: 88% !important;
}

.team_field {
  margin: 10px 0;
  display: flex;
  align-items: center;
  justify-content: space-between;
  position: relative;
  overflow: visible;
}

.team_about {
  overflow: visible !important;
}

.icon__team {
  width: 10%;
}

// .vs__actions::after{
//   z-index: 100;
// }
</style>
